@if (hasUrgentTasks()) {
  <button
    type="button"
    class="due-chip"
    [class.due-chip-overdue]="hasOverdue()"
    (click)="chipClicked.emit()"
    [attr.aria-label]="'Pendientes por atender: ' + label()"
  >
    <ion-icon
      [name]="hasOverdue() ? 'alert-circle-outline' : 'alarm-outline'"
      aria-hidden="true"
    ></ion-icon>
    <span class="due-chip-label">{{ label() }}</span>
  </button>
}
